import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';

import { logout } from '../../actions/auth';
import { getProviderStats } from '../../actions/bookings';

const RESERVAS = '/user/reservas-proveedor';
const COLABORACIONES = '/user/colaboraciones';
// Los números junto a una opción del menú (invitaciones por responder, solicitudes por contestar)
export const CONTADOR = { bgcolor: 'warning.main', color: 'primary.main', fontWeight: 700, height: 22 };

export const menuDrawer = [
  {
    nombre: "Inicio",
    iconName: HomeOutlinedIcon,
    click: '/'
  },
  {
    nombre: "Mis servicios",
    iconName: LanguageOutlinedIcon,
    click: '/user/servicios'
  },
  // Lo que la persona imparte (o le pidieron impartir) en grupos y negocios de otras personas
  {
    nombre: "Servicios que imparto",
    iconName: HandshakeOutlinedIcon,
    click: '/user/colaboraciones'
  },
  {
    nombre: "Reservas",
    iconName: EventNoteOutlinedIcon,
    click: '/user/reservas-proveedor'
  },
  {
    nombre: "Favoritos",
    iconName: FavoriteBorderOutlinedIcon,
    click: '/user/favoritos',
    conMiId: true
  },
  {
    nombre: "Mensajes",
    iconName: EmailOutlinedIcon,
    click: '/mensajes'
  },
  {
    nombre: "Mis tickets",
    iconName: SupportAgentOutlinedIcon,
    click: '/user/tickets'
  },
  {
    nombre: "Perfil",
    iconName: SettingsOutlinedIcon,
    click: '/mi-perfil'
  },
  // La misma página que ven los demás
  {
    nombre: "Ver mi perfil público",
    iconName: VisibilityOutlinedIcon,
    click: '/perfil',
    conMiId: true
  }
];

// El menú de la persona es UNO solo, con las mismas opciones en todos lados: en la computadora sale de su foto (MenuAvatar) y en el celular
// de las tres rayitas (el lateral de Layout); nunca hay dos en una pantalla. `abierto`: si se está viendo, para pedir el número de solicitudes
export const useMenuUsuario = (abierto) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.user);
  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated);
  // Invitaciones a impartir un servicio que la persona aún no responde: se marcan en el menú
  const invitacionesPendientes = useSelector(state => (state.notifications?.notifications || [])
    .filter(n => n.type === 'PAGE_INVITATION' && n.status === 'PENDING').length);
  const { pathname } = useLocation();

  // Solicitudes de reserva por contestar como proveedor (las de «Pendientes» en Reservas): se cuentan cada vez que se abre el menú y, si
  // hay, «Reservas» abre la vista de proveedor, donde están
  const [solicitudes, setSolicitudes] = useState(0);
  useEffect(() => {
    if (!abierto || !isAuthenticated) return;
    let vigente = true;
    getProviderStats().then(stats => { if (vigente) setSolicitudes(stats?.pendiente || 0); });
    return () => { vigente = false; };
  }, [abierto, isAuthenticated]);

  const opciones = menuDrawer.map((item) => {
    const link = item.conMiId && user ? `${item.click}/${user._id}` : item.click;
    return {
      ...item,
      destino: item.click === RESERVAS && solicitudes > 0 ? `${RESERVAS}?vista=proveedor` : link,
      activo: link === pathname,
      contador: item.click === COLABORACIONES ? invitacionesPendientes : item.click === RESERVAS ? solicitudes : 0,
    };
  });

  return { opciones, salir: () => dispatch(logout()) };
};
